import { COLORS, SHAPE_STYLES, TEXT_STYLE } from '../constants';
import { Alignment_Horizontal } from '../shared/api_shared_types';
import type { ButtonStyle, RenderShapeStyle, TextObjectStyle } from '../types';

export const WIDTH = 530;
export const HEIGHT = 900;
export const MIN_GROUP_HEIGHT = 170;

export const SHAPE_BTN_DEFAULT: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 0,
  strokeColor: COLORS.TRANSPARENT,
  fillColor: COLORS.DARKGREY1_100,
};
export const SHAPE_BTN_DEFAULT_HL: RenderShapeStyle = {
  ...SHAPE_BTN_DEFAULT,
  fillColor: [...COLORS.BLUE_CRAYOLA,120],
};

export const SHAPE_BTN_SELECTED: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 0,
  strokeColor: COLORS.TRANSPARENT,
  fillColor: COLORS.BLUE_CRAYOLA,
};

export const SHAPE_STATUS_ACTIVE: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  fillColor: COLORS.GREEN_25,
};

export const SHAPE_STATUS_WARNING: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  fillColor: COLORS.ORANGE_25,
};

export const SHAPE_STATUS_ERROR: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  fillColor: COLORS.RED_25,
};

export const SHAPE_GROUP_DEFAULT: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 2,
  strokeColor: COLORS.GUNMETAL,
  fillColor: COLORS.GAINSBORO,
};

export const SHAPE_GROUP_DEFAULT_HL: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  fillColor: COLORS.WHITE_100,
};

export const SHAPE_GROUP_USERS: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 0,
  strokeColor: COLORS.TRANSPARENT,
  fillColor: COLORS.TRANSPARENT,
};

export const SHAPE_GROUP_USERS_HL: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  fillColor: COLORS.WHITE_10,
};

export const SHAPE_GROUP_WARNING: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 4,
  strokeColor: COLORS.ORANGE_100,
  fillColor: COLORS.GAINSBORO,
};

export const SHAPE_GROUP_WARNING_HL: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 4,
  strokeColor: COLORS.ORANGE_100,
  fillColor: COLORS.WHITE_100,
};

export const SHAPE_GROUP_ERROR: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 4,
  strokeColor: COLORS.RED_SALSA,
  fillColor: COLORS.GAINSBORO,
};

export const SHAPE_GROUP_ERROR_HL: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 4,
  strokeColor: COLORS.RED_SALSA,
  fillColor: COLORS.WHITE_100,
};

export const SHAPE_GROUP_ACTIVE: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 4,
  strokeColor: COLORS.GREEN_100,
  fillColor: COLORS.GAINSBORO,
};

export const SHAPE_GROUP_ACTIVE_HL: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 4,
  strokeColor: COLORS.GREEN_100,
  fillColor: COLORS.WHITE_100,
};

export const SHAPE_USER_DEFAULT: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 2,
  strokeColor: COLORS.BLACK_50,
  fillColor: COLORS.GAINSBORO,
};

export const SHAPE_USER_WARNING: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 4,
  strokeColor: COLORS.ORANGE_100,
  fillColor: COLORS.GAINSBORO,
};

export const SHAPE_USER_ERROR: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 4,
  strokeColor: COLORS.RED_SALSA,
  fillColor: COLORS.GAINSBORO,
};

export const BUTTON_ADD_USER: ButtonStyle = {
  icon: 'buttonContinue',
  color: COLORS.BLUE_CRAYOLA,
  colorHighlight: COLORS.BLUE_HIGHLIGHT,
  size: 16,
  iconSize: 12,
  hoverShadow: true,
};

export const BUTTON_REMOVE_USER: ButtonStyle = {
  icon: 'iconQuit',
  color: COLORS.RED_SALSA,
  colorHighlight: COLORS.RED_HIGHLIGHT,
  size: 16,
  iconSize: 12,
  hoverShadow: true,
};

export const TEXT_BREAKOUT_CONTROLLER_INFO: TextObjectStyle = {
  ...TEXT_STYLE.CONTENT_DEFAULT,
  doAutoResize: false,
  fontSizeEm: 0.8,
  lineHeightMod: 1.2,
  alineaSpacingMod: 1,
};

export const TEXT_GROUP_TITLE: TextObjectStyle = {
  ...TEXT_STYLE.BASE,
  color: COLORS.TRANSPARENT,
  colorHighlight: COLORS.TRANSPARENT,
  defaultTextColor: COLORS.BLACK_100,
  fontSizeEm: 0.9,
  fontId: 'font_bold',
  textAlign: Alignment_Horizontal.CENTER,
  padding: 5,
};

export const TEXT_GROUP_STATUS: TextObjectStyle = {
  ...TEXT_STYLE.BASE,
  color: COLORS.TRANSPARENT,
  colorHighlight: COLORS.TRANSPARENT,
  defaultTextColor: COLORS.BLACK_100,
  fontSizeEm: 0.8,
  fontId: 'font_bold',
  textAlign: Alignment_Horizontal.LEFT,
  padding: 5,
};

export const TEXT_USER_GROUP_NAME: TextObjectStyle = {
  ...TEXT_STYLE.BASE,
  color: COLORS.TRANSPARENT,
  colorHighlight: COLORS.TRANSPARENT,
  defaultTextColor: COLORS.DARKGREY1_100,
  fontSizeEm: 0.7,
  roundedSides: [true, true],
  fontId: 'font_extrabold',
  textAlign: Alignment_Horizontal.CENTER,
  padding: 5,
};

export const TEXT_GROUP_STEP: TextObjectStyle = {
  ...TEXT_STYLE.BASE,
  color: COLORS.GREEN_100,
  colorHighlight: COLORS.GREEN_100,
  defaultTextColor: COLORS.WHITE_100,
  fontSizeEm: 0.7,
  roundedSides: [true, true],
  fontId: 'font_regular',
  textAlign: Alignment_Horizontal.CENTER,
  padding: 5,
};

export const TEXT_BREAKOUT_GROUP_NAME: TextObjectStyle = {
  ...TEXT_STYLE.BASE,
  color: COLORS.TRANSPARENT,
  colorHighlight: COLORS.TRANSPARENT,
  defaultTextColor: COLORS.WHITE_100,
  fontSizeEm: 0.8,
  fontId: 'font_regular',
  textAlign: Alignment_Horizontal.LEFT,
  padding: 5,
};

export const TEXT_USER_NAME: TextObjectStyle = {
  ...TEXT_STYLE.BASE,
  color: COLORS.TRANSPARENT,
  colorHighlight: COLORS.WHITE_25,
  defaultTextColor: COLORS.BLACK_100,
  fontSizeEm: 0.7,
  doAutoResize: false,
  roundedSides: [false, false],
  cornerRadius: [12, 12, 12, 12],
  fontId: 'font_regular',
  textAlign: Alignment_Horizontal.LEFT,
  padding: [7, 10],
};

export const TEXT_USER_STATUS: TextObjectStyle = {
  ...TEXT_STYLE.BASE,
  color: COLORS.TRANSPARENT,
  colorHighlight: COLORS.TRANSPARENT,
  defaultTextColor: COLORS.BLUE_CRAYOLA,
  fontSizeEm: 0.6,
  roundedSides: [false, false],
  cornerRadius: [0, 0, 0, 0],
  fontId: 'font_extrabold',
  textAlign: Alignment_Horizontal.LEFT,
  padding: [5, 5],
};

export const TEXT_USER_STATUS_YOU: TextObjectStyle = {
  ...TEXT_USER_STATUS,
  defaultTextColor: COLORS.NEW_STYLE.BLUE_LIGHT,
};

export const TEXT_USER_STATUS_WARNING: TextObjectStyle = {
  ...TEXT_USER_STATUS,
  defaultTextColor: COLORS.ORANGE_100,
};

export const TEXT_USER_STATUS_PROBLEM: TextObjectStyle = {
  ...TEXT_USER_STATUS,
  defaultTextColor: COLORS.RED_SALSA,
};

export const TEXT_CATEGORY_TITLE: TextObjectStyle = {
  ...TEXT_STYLE.BASE,
  color: COLORS.TRANSPARENT,
  colorHighlight: COLORS.TRANSPARENT,
  defaultTextColor: COLORS.WHITE_50,
  fontSizeEm: 0.9,
  fontId: 'font_bold',
  textAlign: Alignment_Horizontal.CENTER,
  padding: 5,
};


export const LOBBY_STATE_BTN_TEXT: TextObjectStyle = {
  ...TEXT_STYLE.DEFAULT,
  color: COLORS.WHITE_25,
  colorHighlight: COLORS.WHITE_50,
  defaultTextColor: COLORS.WHITE_100,
  doAutoResize: false,
  cornerRadius: [0, 0, 0, 0],
  roundedSides: [false, false],
  fontSizeEm: 0.6,
  padding: [12, 0, 12, 0],
};

export const LOBBY_STATE_TOGGLE: RenderShapeStyle = {
  ...SHAPE_STYLES.NONE,
  strokeWeight: 2,
  strokeColor: COLORS.WHITE_100,
  fillColor: COLORS.TRANSPARENT,
};